import { throttle, debounce } from "//www.edifier.jp/cdn/shop/t/19/assets/extend-common.js?v=35180864842965184011712027866"

// extend footer
function handleFooterMenuInit() {
    const footerMenuHeadingList = document.querySelectorAll('.footer__block--mobile-expand .fb-heading')
    const footerContentList = document.querySelectorAll('.footer__block--mobile-expand .fb-content--mobile-expand')
    const footerMenuPlusIconList = document.querySelectorAll('.footer__block--mobile-expand .fbm-icon--plus')
    const footerMenuMinusIconList = document.querySelectorAll('.footer__block--mobile-expand .fbm-icon--minus')
    let isEventAttached = false;
    let animationTime = 400
    function toggleFooterMenu(event) {
        const currentFooterMenu = event.currentTarget.nextElementSibling
        const currentPlusIcon = event.currentTarget.querySelector('.fbm-icon--plus')
        const currentMinusIcon = event.currentTarget.querySelector('.fbm-icon--minus')
        let footerMenuDisplay = false
        if (currentFooterMenu.style.display == 'none') footerMenuDisplay = !footerMenuDisplay;
        if (footerMenuDisplay) {
            currentFooterMenu.style.display = 'grid';
            currentPlusIcon.style.transform = 'rotate(90deg)'
            window.setTimeout(() => {
                currentPlusIcon.style.display = 'none';
                currentPlusIcon.style.transform = 'rotate(0deg)'
                currentMinusIcon.style.display = 'block';
            }, animationTime)
        } else {
            currentMinusIcon.style.transform = 'rotate(-90deg)'
            window.setTimeout(() => {
                currentFooterMenu.style.display = 'none';
                currentPlusIcon.style.display = 'block';
                currentMinusIcon.style.display = 'none';
                currentMinusIcon.style.transform = 'rotate(0deg)'
            }, animationTime)
        }
        currentFooterMenu.style.height = footerMenuDisplay ? currentFooterMenu.scrollHeight + "px" : 0;
    }

    function handleResize() {
        if (window.innerWidth <= 699) {
            footerContentList.forEach(menu => {
                menu.style.display = 'none'
                // menu.style.overflow = 'hidden'
                // menu.style.height = 0
            })
            footerMenuHeadingList.forEach(heading => {
                heading.style.cursor = 'pointer'
            })
            footerMenuPlusIconList.forEach(icon => {
                icon.style.display = 'block'
            })
            footerMenuMinusIconList.forEach(icon => {
                icon.style.display = 'none'
            })
            if (!isEventAttached) {
                isEventAttached = true
                footerMenuHeadingList.forEach(heading => {
                    heading.removeEventListener('click', toggleFooterMenu);
                    heading.addEventListener('click', toggleFooterMenu)
                })
            }
        } else {
            footerContentList.forEach(footerMenu => {
                footerMenu.style.display = 'grid';
                footerMenu.style.height = 'auto'
            });
            footerMenuHeadingList.forEach(heading => {
                heading.style.cursor = 'default'
            })
            footerMenuPlusIconList.forEach(icon => {
                icon.style.display = 'none'
            })
            footerMenuMinusIconList.forEach(icon => {
                icon.style.display = 'none'
            })
            if (isEventAttached) {
                footerMenuHeadingList.forEach(heading => {
                    heading.removeEventListener('click', toggleFooterMenu);
                });
                isEventAttached = false
            }
        }
    }

    // const throttledHandleResize = throttle(handleResize, 100);
    const debouncedHandleResize = debounce(handleResize, 100)

    window.addEventListener('resize', debouncedHandleResize)

    debouncedHandleResize()
}

handleFooterMenuInit()

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
  let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
  let form = event.target; // The form that triggers the change
  const amazonAsinAll = document.querySelector('#amazonAsinAll')?.textContent.replace(/\s+/g, '');
  const amazonAsinSpecList = document.querySelector('#amazonAsinSpecList')?.textContent.replace(/\s+/g, '').split(',');
  if (amazonAsinSpecList?.length) {
    const amazonAsinSpecInfo = amazonAsinSpecList.map((item) => {
			const itemSplitArr = item.split("|");
			const asin = itemSplitArr[0];
			const variantId = itemSplitArr[1];
			return {
				asin,
				variantId,
			};
		});
		amazonAsinSpecInfo.forEach((item) => {
			if (item.variantId == variant.id) {
				const amazonLinkElement = document.querySelector("#amazonLink");
				const amazonBaseUrl = 'https://amazon.co.jp/dp/'
				if (item.asin) {
					if (item.asin == 'none') {
						amazonLinkElement.style.display = 'none';
					} else {
						amazonLinkElement.href = amazonBaseUrl + item.asin;
						amazonLinkElement.style.display = 'inline-block';
					}
				} else if (amazonAsinAll) {
					if (amazonAsinAll == 'none') {
							amazonLinkElement.style.display = 'none';
					} else {
							amazonLinkElement.href = amazonBaseUrl + amazonAsinAll
							amazonLinkElement.style.display = 'inline-block';
					}
				} else {
					amazonLinkElement.style.display = 'none';
				}
			}
		});
	}

	

	const rakutenSkuAll = document.querySelector('#rakutenSkuAll')?.textContent.replace(/\s+/g, '');
	const rakutenStoreId = document.querySelector('#rakutenStoreId')?.textContent.replace(/\s+/g, '');
	const rakutenSkuSpecList = document.querySelector('#rakutenSkuSpecList')?.textContent.replace(/\s+/g, '').split(',');
	if (rakutenSkuSpecList?.length) {
		const rakutenSkuSpecInfo = rakutenSkuSpecList.map((item) => {
			const itemSplitArr = item.split("|");
			const sku = itemSplitArr[0];
			const variantId = itemSplitArr[1];
			return {
				sku,
				variantId,
			};
		});
		rakutenSkuSpecInfo.forEach((item) => {
			if (item.variantId == variant.id) {
				const rakutenLinkElement = document.querySelector("#rakutenLink");
				const rakutenBaseUrl = 'https://item.rakuten.co.jp/' + rakutenStoreId + '/'
				if (item.sku) {
					if (item.sku == 'none') {
						rakutenLinkElement.style.display = 'none';
					} else {
						rakutenLinkElement.href = rakutenBaseUrl + item.sku;
						rakutenLinkElement.style.display = 'inline-block';
					}
				} else if (rakutenSkuAll) {
					if (rakutenSkuAll == 'none') {
						rakutenLinkElement.style.display = 'none';
					} else {
						rakutenLinkElement.href = rakutenBaseUrl + rakutenSkuAll
						rakutenLinkElement.style.display = 'inline-block';
					}
				} else {
					rakutenLinkElement.style.display = 'none';
				}
			}
		});
	}

	
});
